import gql from 'graphql-tag';

import integrationFragment from '../fragments/integrationFragment';

export const mutationCreateIntegrationDesktop = gql`
  mutation createIntegrationDesktop (
    $name: String!
    $syncFolderPath: String!
    $machineID: ID!
  ) {
    createIntegrationDesktop (
      name: $name
      syncFolderPath: $syncFolderPath
      machineID: $machineID
    ) {
      ...integrationFragment
    }
  }
  ${integrationFragment}
`;
export default mutationCreateIntegrationDesktop;
